var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"mw-modal\">\n<img src=\"" + require("../../assets/alert-message.svg") + "\" alt=\"\"/>\n<h2>\nStart Archiving </h2>\n<p>\nAre you sure you want to start archiving?\n</p>\n<div class=\"mw-modal-op\">\n<a class=\"mw-btn mw-btn-cancel\" ng-click=\"cancel()\">No, Go Back</a>\n<a class=\"mw-btn\" ng-click=\"ok()\">Yes, Continue</a>\n</div>\n</div>\n";
var id1="app/modal/archiving.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;